import { combineReducers } from "redux";

// Front
import Layout from "./layouts/reducer";

// Dashboard Analytics
import DashboardAnalytics from "./dashboardAnalytics/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import ResetPassword from "./auth/resetpwd/reducer";
import Profile from "./auth/profile/reducer";
import ChangePassword from "./auth/changepwd/reducer";
import TenantSettings from "./tenant-settings/reducer";

// Team
import Team from "./team/reducer";

// Company
import Company from "./company/reducer";

// Channel
import Channel from "./channel/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  ResetPassword,
  Profile,
  DashboardAnalytics,
  Team,
  Company,
  ChangePassword,
  TenantSettings,
  Channel,
});

export default rootReducer;
